/**
 * Ajoute une notice dans les metaboxes de taxonomie pour indiquer qu'un seul élément doit être sélectionné
 */
(function($) {
    'use strict';
    
    $(document).ready(function() {
        // Fonction pour ajouter la notice
        function addSingleSelectNotice() {
            // Cibler les metaboxes category et univers_metiers
            var $categoryDiv = $('#categorydiv');
            var $universMetiersDiv = $('#univers_metiersdiv');
            
            // Message d'information
            var noticeHtml = '<p class="description" style="margin-top: 10px; padding: 8px; background: #fff3cd; border-left: 4px solid #ffc107; color: #856404;">' +
                '<strong>ℹ️ Information :</strong> Bien que plusieurs sélections soient possibles, veuillez sélectionner <strong>un seul élément</strong> pour un affichage optimal.' +
                '</p>';
            
            // Ajouter la notice dans categorydiv si elle n'existe pas déjà
            if ($categoryDiv.length && !$categoryDiv.find('.single-select-notice').length) {
                $categoryDiv.prepend(noticeHtml);
                $categoryDiv.find('.description').last().addClass('single-select-notice');
            }
            
            // Ajouter la notice dans univers_metiersdiv si elle n'existe pas déjà
            if ($universMetiersDiv.length && !$universMetiersDiv.find('.single-select-notice').length) {
                $universMetiersDiv.prepend(noticeHtml);
                $universMetiersDiv.find('.description').last().addClass('single-select-notice');
            }
        }
        
        // Ajouter la notice au chargement de la page
        addSingleSelectNotice();
        
        // Ajouter la notice après les mises à jour AJAX (si la page est mise à jour dynamiquement)
        $(document).on('DOMNodeInserted', function(e) {
            if ($(e.target).is('#categorydiv, #univers_metiersdiv') || 
                $(e.target).find('#categorydiv, #univers_metiersdiv').length) {
                setTimeout(addSingleSelectNotice, 100);
            }
        });
    });
})(jQuery);

